import React from 'react';

export const ContactsIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1596 10.6919C11.1596 10.0536 10.9362 9.50041 10.4787 9.04296C10.0213 8.58551 9.47872 8.36211 8.82979 8.36211C8.18085 8.36211 7.6383 8.58551 7.18085 9.04296C6.7234 9.50041 6.5 10.043 6.5 10.6919C6.5 11.3408 6.7234 11.8834 7.18085 12.3408C7.6383 12.7983 8.18085 13.0217 8.82979 13.0217C9.47872 13.0217 10.0213 12.7983 10.4787 12.3408C10.9362 11.8834 11.1596 11.3408 11.1596 10.6919Z"
        fill={className}
      />
      <path
        d="M14.6489 14.1811C13.9999 14.1811 13.4254 14.2449 12.8935 14.3619C14.0957 15.1917 14.3616 16.2555 14.3616 17.0321V18.6598C16.0957 18.0534 17.5318 16.8194 18.3829 15.2236L18.3287 15.1789C18.2319 15.0985 18.1379 15.0205 18.0212 14.9577C17.1701 14.447 16.0425 14.1917 14.6489 14.1917V14.1811Z"
        fill={className}
      />
      <path
        d="M13.4788 18.9149V17.0426C13.4788 16.3936 13.2341 15.8298 12.7554 15.383C12.5958 15.2341 12.4043 15.0958 12.1915 14.9681C12.0426 14.883 11.883 14.8085 11.7234 14.7447C11.3298 14.5638 10.8937 14.4362 10.4043 14.3404C9.91494 14.2447 9.39366 14.2021 8.80855 14.2021C7.766 14.2021 6.86174 14.3511 6.1277 14.6383C5.88302 14.7341 5.65962 14.8404 5.44685 14.9681C6.61706 17.4043 9.09579 19.0851 11.9681 19.0851C12.4788 19.0851 12.9788 19.0319 13.4575 18.9256L13.4788 18.9149Z"
        fill={className}
      />
      <path
        d="M14.6489 13.0217C15.2872 13.0217 15.8404 12.7983 16.2978 12.3408C16.7553 11.8834 16.9787 11.3408 16.9787 10.6919C16.9787 10.043 16.7553 9.50041 16.2978 9.04296C15.8404 8.58551 15.2978 8.36211 14.6489 8.36211C13.9999 8.36211 13.4574 8.58551 12.9999 9.04296C12.5425 9.50041 12.3191 10.043 12.3191 10.6919C12.3191 11.3408 12.5425 11.8834 12.9999 12.3408C13.4574 12.7983 13.9999 13.0217 14.6489 13.0217Z"
        fill={className}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2C17.5106 2 21.9894 6.48936 21.9894 12H22C22 17.5106 17.5106 22 12 22C6.48936 22 2 17.5106 2 12C2 6.48936 6.48936 2 12 2ZM12 3.84043C7.48936 3.84043 3.84043 7.48936 3.84043 12C3.84043 16.5 7.48936 20.1596 12 20.1596C16.5106 20.1596 20.1596 16.5106 20.1596 12C20.1596 7.48936 16.5106 3.84043 12 3.84043Z"
        fill={className}
      />
    </svg>
  );
};

// Figma: new contact
